export var Sender;
(function (Sender) {
    /** Unknown sender type. */
    Sender["UNKNOWN"] = "UNKNOWN";
    /** AI assistant. */
    Sender["ASSISTANT"] = "ASSISTANT";
    /** Wix user. For example, a site admin. */
    Sender["USER"] = "USER";
    /** Message was sent automatically due to widget settings. For example, a contact form. */
    Sender["SYSTEM"] = "SYSTEM";
    /** Site visitor. */
    Sender["SITE_VISITOR"] = "SITE_VISITOR";
})(Sender || (Sender = {}));
export var MessageType;
(function (MessageType) {
    /** Unknown message type. */
    MessageType["UNKNOWN_MESSAGE_TYPE"] = "UNKNOWN_MESSAGE_TYPE";
    /** Question. */
    MessageType["QUESTION"] = "QUESTION";
    /** Answer. */
    MessageType["ANSWER"] = "ANSWER";
    /** Intro message, as defined in the widget settings. */
    MessageType["INTRO"] = "INTRO";
    /** Legal disclaimer, as defined in the widget settings. */
    MessageType["LEGAL"] = "LEGAL";
    /** Contact form. */
    MessageType["CONTACT_FORM"] = "CONTACT_FORM";
    /** Message confirms that a contact form was successfully submitted. */
    MessageType["CONTACT_FORM_SUBMITTED"] = "CONTACT_FORM_SUBMITTED";
    /** Notification for the site owner. */
    MessageType["SITE_OWNER_NOTIFICATION"] = "SITE_OWNER_NOTIFICATION";
    /** Message informing the site visitor that the AI assistant is offline, as defined in the widget settings. */
    MessageType["OFFLINE"] = "OFFLINE";
    /** Message that informs the Wix user that they have reached the maximum number of messages on their current plan. */
    MessageType["OUT_OF_QUOTA"] = "OUT_OF_QUOTA";
    /** User answer. */
    MessageType["USER_ANSWER"] = "USER_ANSWER";
    /** Site visitor site Navigation information. */
    MessageType["SITE_NAVIGATION"] = "SITE_NAVIGATION";
    /** Site visitor site Navigation information answer. */
    MessageType["NAVIGATION_ANSWER"] = "NAVIGATION_ANSWER";
    /** AI Site Chat ignored the question. */
    MessageType["IGNORED_ANSWER"] = "IGNORED_ANSWER";
    /** Site visitor selected an option from  Message.visitor_options. */
    MessageType["VISITOR_OPTION_SELECTED"] = "VISITOR_OPTION_SELECTED";
    /** Site visitor added a product to the cart. */
    MessageType["ADD_TO_CART"] = "ADD_TO_CART";
    /** Site visitor booked a service. */
    MessageType["BOOK_SERVICE"] = "BOOK_SERVICE";
    /** AI assistant generated a question for the user to try. */
    MessageType["GENERATED_QUESTION"] = "GENERATED_QUESTION";
    /** Suggested question, as defined in the widget settings. */
    MessageType["SUGGESTED_QUESTION"] = "SUGGESTED_QUESTION";
    /** Wix user question for testing and training. */
    MessageType["USER_QUESTION"] = "USER_QUESTION";
    /** Wix assistant answer for testing and training. */
    MessageType["USER_QUESTION_ANSWER"] = "USER_QUESTION_ANSWER";
})(MessageType || (MessageType = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map